import React from 'react';
import { Link } from 'react-router-dom';

const TerminosCondiciones = () => {
  return (
    <div className="legal-container">
      <h1>Términos y Condiciones</h1>
      <p className="update-date">Última actualización: 28 de mayo de 2025</p>

      <p>
        Bienvenido al sitio web y canales digitales de Sana Servicios Dentales. Al acceder, navegar o utilizar nuestros servicios digitales,
        usted acepta expresamente regirse por los siguientes Términos y Condiciones de Uso. Si no está de acuerdo,
        le solicitamos no utilizar este sitio web ni proporcionar datos personales por medio de formularios digitales.
      </p>

      <h2>1. Datos de la clínica</h2>
      <ul>
        <li><strong>Nombre comercial:</strong> Sana Servicios Dentales</li>
        <li><strong>Domicilio:</strong> Oriente 4 #315, entre Sur 7 y Sur 9, Orizaba, Veracruz, C.P. 94300</li>
        <li><strong>Correo electrónico:</strong> sanaservidental@gmail.com</li>
        <li><strong>Teléfono:</strong> 2721986870</li>
        <li><strong>Cofepris:</strong> 2330075056X00007</li>
      </ul>

      <h2>2. Objeto</h2>
      <p>
        Estos Términos y Condiciones regulan el acceso y uso del sitio web y medios electrónicos de Sana Servicios Dentales,
        cuyo objetivo principal es informar sobre los servicios dentales ofrecidos, agendar citas, brindar orientación inicial,
        y permitir el contacto directo entre pacientes y la clínica.
      </p>

      <h2>3. Uso del sitio</h2>
      <p>
        El usuario se compromete a utilizar este sitio y sus contenidos de manera lícita, conforme a la legislación aplicable,
        la moral, las buenas costumbres y el orden público. Queda estrictamente prohibido el uso del sitio para fines fraudulentos,
        difamatorios, o que infrinjan derechos de terceros.
      </p>

      <h2>4. Servicios promocionados</h2>
      <p>
        La información sobre tratamientos, promociones y precios publicada en este sitio es meramente informativa y está sujeta a cambios sin previo aviso.
        Todo diagnóstico y presupuesto final requiere una valoración presencial en la clínica por parte del profesional de salud dental.
      </p>

      <h2>5. Limitación de responsabilidad</h2>
      <p>
        Sana Servicios Dentales no garantiza que el sitio esté libre de errores o interrupciones técnicas.
        La clínica no se hace responsable por daños o pérdidas derivadas del uso del sitio, ni por malinterpretaciones de la información publicada.
        El uso de la información médica proporcionada es bajo responsabilidad del usuario y no sustituye una consulta profesional.
      </p>

      <h2>6. Propiedad intelectual</h2>
      <p>
        Todos los elementos del sitio (textos, logotipos, imágenes, videos, íconos, diseño gráfico, contenido informativo)
        son propiedad de Sana Servicios Dentales o se utilizan con autorización. Está prohibido copiar, reproducir o distribuir dichos elementos
        sin autorización expresa y por escrito.
      </p>

      <h2>7. Política de datos personales</h2>
      <p>
        Al utilizar nuestros formularios de contacto, citas en línea o cualquier canal de comunicación,
        el usuario acepta el tratamiento de sus datos personales conforme al{' '}
        <Link to="/aviso-privacidad">Aviso de Privacidad</Link>.

      </p>

      <h2>8. Enlaces a terceros</h2>
      <p>
        Este sitio puede contener enlaces a sitios web o servicios de terceros. Sana Servicios Dentales no se hace responsable
        del contenido, seguridad o políticas de privacidad de dichos sitios externos.
      </p>

      <h2>9. Modificaciones a los términos</h2>
      <p>
        Sana Servicios Dentales se reserva el derecho de modificar en cualquier momento estos Términos y Condiciones.
        Las modificaciones entrarán en vigor en cuanto se publiquen en el sitio. Es responsabilidad del usuario revisar periódicamente este apartado.
      </p>

      <h2>10. Legislación aplicable y jurisdicción</h2>
      <p>
        Este acuerdo se regirá por las leyes aplicables en los Estados Unidos Mexicanos. Para la resolución de cualquier controversia,
        las partes se someten a la jurisdicción de los tribunales competentes en Orizaba, Veracruz, renunciando expresamente
        a cualquier otro fuero que pudiera corresponderles por razón de domicilio presente o futuro.
      </p>
    </div>
  );
};

export default TerminosCondiciones;
